module.exports = __webpack_public_path__ + "img/smsnotificatoin.be8aa627.webp";